module.exports = __webpack_public_path__ + "img/Dell_Technologies_logo-full-color.8b58d29d.svg";